<script>
	
	export default {
		props:['propertie'],
		data(){
			return {
				modalVisible:false,
				detalheLoteVisible:true,
				gerarLoteVisible:false,
				title:"Detalhes do Lote"
			}
		},
		methods: {
			editar(id){
				this.modalVisible = !this.modalVisible;

			},
			fechar(){
				this.modalVisible = !this.modalVisible;
			},
			changeScreeToGerarLote(){
				this.title = "Gerar Lote";
				this.detalheLoteVisible = false;
				this.gerarLoteVisible = true;
			},
			changeScreeToDetalheLote(){
				this.title = "Detalhes do Lote";
				this.detalheLoteVisible = true;
				this.gerarLoteVisible = false;			
			}
		}
	}

</script>

<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<button class="btn btn-success pull-right" @click="changeScreeToGerarLote" v-if="!gerarLoteVisible">
					<i class="fa fa-plus"></i> Gerar Lote</button>
				<button class="btn btn-success pull-right" @click="changeScreeToDetalheLote" v-if="!detalheLoteVisible">
					<i class="fa fa-list"></i> Detalhes Lote</button>
			</div>

			<div class="col-md-12">
				<h2 >{{ title }}</h2>
			</div>
		</div>
		<div class="row" v-if='!modalVisible'>

			<div class="col-md-6" >
				<div class="col-md-6">
					<label for="">De</label>
					<date-picker value="null"></date-picker>
				</div>
				<div class="col-md-6">
					<label for="">Até</label>
					<date-picker value="null"></date-picker>
				</div>
			</div>

			<div class="col-md-6">
				
				<label class="sr-only" for="inlineFormInputGroup">Código, Nome ou Lote</label>
				<div class="input-group mb-2 mr-sm-2 mb-sm-0 inline-form-input-group-top-25">

					<input type="text" class="form-control" id="inlineFormInputGroup" placeholder="Nome ou Código">
					<div class="input-group-addon"><i class="fa fa-search"></i></div>
				</div>
			</div>
		</div>
		

		<div class="row" v-if='!modalVisible'>
			<div class="col-md-12">

				<table class="table table-responsive table-striped table-bordered table-hover">

					<thead>
						<tr class="text-center">
							<th>Código</th>
							<th>Lote</th>
							<th>Nome</th>
							<th>Pedidos</th>
							<th>Itens</th>
							<th>Data/Hora</th>
							<th>Situação</th>
							<th>&nbsp;</th>
							<th>&nbsp;</th>
						</tr>

					</thead>

					<tbody>

						<tr>
							<td>1234</td>
							<td>56789</td>
							<td>Francisco da Silva</td>
							<td>2</td>
							<td>100</td>
							<td>01/01/2017 00:00</td>
							<td>Aguardando Recebimento</td>
							<td class="text-center">
								<button type="button" class="btn btn-primary" @click="editar(1)">
									<i class="fa fa-eye"></i>
								</button>
							</td>
							<td class="text-center">
								<button type="button" class="btn btn-primary" @click="editar(1)">
									<i class="fa fa-arrow-circle-down"></i>
								</button>
							</td>
						</tr>


					</tbody>
				</table>



			</div>
		</div>

		<transition name="slide-fade">
			<div class="row vue-modal" v-if='modalVisible'>
				<div class="col-md-6 col-sm-12 col-md-offset-3">

					<div class="panel panel-default">
						<div class="panel-heading"> <strong></strong>1 - Nome do Distribuidor</div>
						<div class="panel-body">

							<p>
								<strong>Classe:</strong>A
							</p>

							<p><strong>CNPJ:</strong> 000.000.000/000.-00</p>

							<p><strong>E-mail:</strong> distribuidor@mail.com</p>

							<p><strong>Contato:</strong> Carolina</p>

							<p><strong>DDD:</strong> 33


								<strong>Telefone:</strong>
								3333-3333

								<strong>Telefone 2:</strong>
								3333-3333

								<strong>Telefone 3:</strong>
								3333-3333
							</p>
							<p><strong>Celular:</strong> 9 0000-0000</p>
							<p><strong>Endereço:</strong> Rua Xy nº50 Centro Gyn Go <strong>CEP</strong> 00 000-000</p>


							<div class="col sm-6"><strong>Itens Enviados:</strong> 0</div>
							<div class="col sm-6"><strong>Itens Mês anterior:</strong> 0</div>

						</div>
						<div class="panel-footer text-right">


							<button class="btn btn-default"><i class="fa fa-send"></i> Email</button>
							<button class="btn"><i class="fa fa-arrow-circle-right"></i> Logar</button>
							<button class="btn" @click='fechar'>FECHAR</button>

						</div>
					</div>

				</div>
			</div>
		</transition>

	</div>
</template>



// WEBPACK FOOTER //
// resources/assets/js/components/lote/Lote.vue